import React, { useState } from 'react'
import './../../App.css';
import './LoginStyles.css';
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';




function SignUp() {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [userType, setUserType] = useState('Select User Type');
    const navigate = useNavigate();
    const passwordRequirements = [
        { id: 1, test: (password) => password.length >= 8, message: "At least 8 characters" },
        { id: 2, test: (password) => /[A-Z]/.test(password), message: "At least one uppercase letter" },
        { id: 3, test: (password) => /[a-z]/.test(password), message: "At least one lowercase letter" },
        { id: 4, test: (password) => /\d/.test(password), message: "At least one number" },
        { id: 5, test: (password) => /[\W_]/.test(password), message: "At least one symbol" },
        { id: 6, test: (password, confirmPassword) => password === confirmPassword && password.length > 0, message: "Passwords must match" }
    ];
    const [validation, setValidation] = useState(passwordRequirements.map(req => ({ ...req, isValid: false })));
    const apiUrl = process.env.REACT_APP_API_BASE_URL;


    const handleSubmit = async (e) => {
        e.preventDefault();

        // Construct the user data
        const userData = {
            firstName,
            lastName,
            email,
            password, // This is the hashed password
            userType
        };

        try {
            const response = await fetch(`${apiUrl}/signup`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(userData)
            });

            if (response.ok) {
                alert("User Successfully Created!");
                navigate('/login'); // Redirect after clicking "OK" in the alert
            } else {
                const error = await response.json();
                alert(`Failed to create user: ${error.message}`);
            }
        } catch (error) {
            console.error('Error:', error);
            alert("An error occurred during registration.");
        }
    };
    const handlePasswordChange = (event) => {
        const newPassword = event.target.value;
        setPassword(newPassword);

        const newValidation = passwordRequirements.map(req => ({
            ...req,
            isValid: req.id === 6 ? req.test(newPassword, confirmPassword) : req.test(newPassword)
        }));

        setValidation(newValidation);
    };
    const handleConfirmPasswordChange = (event) => {
        const newConfirmPassword = event.target.value;
        setConfirmPassword(newConfirmPassword);

        const passwordMatchRequirement = validation.map(req => req.id === 6 ? { ...req, isValid: req.test(password, newConfirmPassword) } : req);
        setValidation(passwordMatchRequirement);
    };
    return (
        <div className='signup-page template d-flex justify-content-center align-items-center vh-100 bg-secondary'>
            <div className='form_container p-5 rounded bg-white'>
                <form onSubmit={handleSubmit}>
                    <h3 className='text-center'>Sign Up</h3>
                    <div className='mb-2'>
                        <label htmlFor='fname'>First Name</label>
                        <input type='text' className='form-control' value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                    </div>
                    <div className='mb-2'>
                        <label htmlFor='lname'>Last Name</label>
                        <input type='text' className='form-control' value={lastName} onChange={(e) => setLastName(e.target.value)} />
                    </div>
                    <div className='mb-2'>
                        <label htmlFor='email'>Email</label>
                        <input type='email' className='form-control' value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className='mb-2'>
                        <label htmlFor='password'>Password</label>
                        <input type='password' className='form-control' value={password} onChange={handlePasswordChange} />
                    </div>
                    <div id="passwordHelpBlock" className="form-text">
                        {validation.map(req => (
                            <div key={req.id} className={`text-${req.isValid ? 'success' : 'danger'}`}>
                                {req.isValid ? <span>&#10003;</span> : <span>&#10007;</span>} {req.message}
                            </div>
                        ))}
                    </div>
                    <div className='mb-2'>
                        <label htmlFor='confirmPassword'>Confirm Password</label>
                        <input type='password' className='form-control' value={confirmPassword} onChange={handleConfirmPasswordChange} />
                    </div>
                    <div className='mb-2'>
                        <label htmlFor='userType'>What kind of user are you?</label>
                        <div class="dropdown">
                            <button class="btn btn-success dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                {userType}
                            </button>
                            <ul className="dropdown-menu">
                                <li><button className="dropdown-item" type="button" onClick={() => setUserType('Teacher')}>Teacher</button></li>
                                <li><button className="dropdown-item" type="button" onClick={() => setUserType('Student')}>Student</button></li>
                                <li><button className="dropdown-item" type="button" onClick={() => setUserType('Traveler')}>Traveler</button></li>
                            </ul>
                        </div>
                    </div>
                    <div className='d-grid mt-2'>
                        <button className='btn btn-success'>Sign Up</button>
                    </div>
                    <p className='text-end mt-2'>
                        Already Registered?<Link to="/login" className='ms-2'>Log In</Link>
                    </p>
                </form>
            </div>
        </div>
    )
}
export default SignUp;